import React from "react";

export default function Navbar(){

    return( 
        <nav className="navbar bg-body shadow">
        <div className="container-fluid">
         <a className="navbar-brand" href="/"><strong className="p-3">
         <label className="" style={{backgroundColor:"red", height:"30px",color:"white"}}>Al</label>maBetter
         </strong></a>
         
        </div>
        </nav>
    )
}